import { useEffect } from "react"

export default function sendPageTrackingEvent(name: string) {
  useEffect(() => {
    if (process.env.ARE_ANALYTICS_ENABLED) {
      // Analytics.record({ name: "location", attributes: { name } })
    }
  }, [])
}
